import React from 'react';
import { motion } from 'framer-motion';

interface Line {
  id: number;
  color: string;
  delay: number;
  position: string;
  height?: string;
  top?: string;
  direction?: 'up' | 'down';
}

const BackgroundLines: React.FC = () => {
  const lines: Line[] = [
    { id: 1, color: '#666', delay: 0, position: '10%' },
    { id: 2, color: '#666', delay: 0.2, position: '20%' },
    { id: 3, color: '#666', delay: 0.4, position: '30%' },
    { id: 4, color: '#666', delay: 0.6, position: '40%' },
    { id: 5, color: '#666', delay: 0.8, position: '50%' },
    { id: 6, color: '#666', delay: 1.0, position: '60%' },
    { id: 7, color: '#666', delay: 1.2, position: '70%' },
    { id: 8, color: '#666', delay: 1.4, position: '80%' },
    { id: 9, color: '#666', delay: 1.6, position: '90%' },
  ];

  // Ortadaki 3 gri çizgi 
  const centerLines: Line[] = [
    { id: 20, color: '#666', delay: 0.3, position: '48%' },
    { id: 21, color: '#666', delay: 0.5, position: '50%' },
    { id: 22, color: '#666', delay: 0.7, position: '52%' },
  ];

  
  const orangeLines: Line[] = [
    
    { id: 30, color: 'linear-gradient(to bottom, transparent, #ff6b35, #ff8c42, #ff6b35, transparent)', delay: 0, position: '50%', height: '40vh', top: '0', direction: 'down' },
    { id: 31, color: 'linear-gradient(to top, transparent, #ff6b35, #ff8c42, #ff6b35, transparent)', delay: 0, position: '50%', height: '40vh', top: '60%', direction: 'up' },
    { id: 32, color: 'linear-gradient(to bottom, transparent, #ff6b35, #ff8c42, #ff6b35, transparent)', delay: 0.5, position: '48%', height: '40vh', top: '0', direction: 'down' },
    { id: 33, color: 'linear-gradient(to top, transparent, #ff6b35, #ff8c42, #ff6b35, transparent)', delay: 0.5, position: '48%', height: '40vh', top: '60%', direction: 'up' },
    { id: 34, color: 'linear-gradient(to bottom, transparent, #ff6b35, #ff8c42, #ff6b35, transparent)', delay: 1.0, position: '52%', height: '40vh', top: '0', direction: 'down' },
    { id: 35, color: 'linear-gradient(to top, transparent, #ff6b35, #ff8c42, #ff6b35, transparent)', delay: 1.0, position: '52%', height: '40vh', top: '60%', direction: 'up' },
  ];

  const allLines = [...lines, ...centerLines, ...orangeLines];

  return (
    <div className="background-lines">
      {allLines.map((line) => (
        <motion.div
          key={line.id}
          className="background-line"
          style={{
            left: line.position,
            background: line.color.includes('linear-gradient') ? line.color : line.color,
            backgroundColor: line.color.includes('linear-gradient') ? 'transparent' : line.color,
            height: line.height || '100vh',
            top: line.top || '0',
            width: line.color.includes('linear-gradient') ? '3px' : '1px',
          }}
          initial={{ 
            opacity: 0, 
            y: -100,
            height: 0 
          }}
          animate={{ 
            opacity: line.color.includes('linear-gradient') ? 1 : 0.3, 
            y: line.color.includes('linear-gradient') ? 
              (line.direction === 'down' ? [0, 50, 0] : [0, -50, 0]) : 0,
            height: line.height || '100vh'
          }}
          transition={{ 
            duration: line.color.includes('linear-gradient') ? 3 : 2, 
            delay: line.delay,
            ease: line.color.includes('linear-gradient') ? "easeInOut" : "easeOut",
            repeat: line.color.includes('linear-gradient') ? Infinity : 0,
            repeatType: line.color.includes('linear-gradient') ? "reverse" : undefined
          }}
        />
      ))}
    </div>
  );
};

export default BackgroundLines;
